const translations = {
  "en": {
    "Transcribing....": "Transcribing...."
  },
  "zh-tw": {
    "Transcribing....": "辨識中……"
  }
};

export default translations;
